import { InjectionToken } from '@angular/core';
import { HolidaysPort } from './holidays.port';

export const HOLIDAYS_PORT = new InjectionToken<HolidaysPort>('HOLIDAYS_PORT');
